/** Provider messages can reveal sensitive risk decisions. Only known safe
 * categories are translated; everything else receives the same neutral copy. */
export function checkoutDeclineMessage(error: { code?: string | null; decline_code?: string | null }, t: (key: string, options?: Record<string, unknown>) => string): string {
  const code = error.decline_code || error.code;
  const safe = code === "insufficient_funds" ? "insufficient_funds"
    : code === "expired_card" || code === "card_expired" ? "expired_card"
    : code === "incorrect_cvc" || code === "invalid_cvc" ? "incorrect_cvc"
    : code === "authentication_required" ? "authentication_required" : "card_declined";
  const fallback = {
    insufficient_funds: "Your card has insufficient funds. Try another card or contact your bank.",
    expired_card: "Your card has expired. Use a different card.",
    incorrect_cvc: "The card security code is incorrect. Check it and try again.",
    authentication_required: "Your bank needs you to verify this payment. Try again and complete the bank's verification.",
    card_declined: "Your payment could not be completed. Try another card or contact your bank.",
  };
  return t(`checkout.recovery.${safe}`, { defaultValue: fallback[safe] });
}
